var divider_viewer_default = {
  "divider-container": "nADil",
  "divider-container--double": "_8h89m",
  "divider": "WDiHn",
  "divider--single": "BmUlZ",
  "divider--double": "v-rAl",
  "divider--dashed": "igJSh",
  "divider--dotted": "_7hMoe",
  "divider--small": "dxatW",
  "divider--medium": "EGWpQ",
  "divider--large": "f1J9M",
  "divider--left": "gBJRe",
  "divider--center": "wD8il",
  "divider--right": "_5oIF-",
  "svgFixerContainer": "iMOzg",
  "emptyChar": "KMZQQ"
};
export {
  divider_viewer_default as default
};
//# sourceMappingURL=divider-viewer-scss.js.map
